import { LAYOUT } from '@admin/router/constant'

// 调拨v2
const containerManagementRouter = {
  path: '/container_management',
  name: '',
  component: LAYOUT,
  children: [
    {
      path: '/wms/transfer/bundling',
      name: 'WMSTransferBundingPage',
      component: () => import('@admin/views/wms/transfer/bundling/index.vue'),
      meta: { title: '集束捆扎作业' },
    },
    {
      path: '/wms/container_management/bundle/list',
      name: 'WMSTContainerManagementBundleList',
      component: () => import('@admin/views/wms/containerManagement/bundleList/index.vue'),
      meta: { title: '集束捆扎列表' },
    },
  ],
}

export default [containerManagementRouter]
